import { TobaccoUser } from './tobaccoUser';

export class Dependent implements TobaccoUser {
  // fields from TobaccoUser
  isOverTobaccoAgeLimit: boolean;

  tobaccoIndicator: string;

  tobaccoUseEffectiveBeginDate: string;

  tobaccoUseEffectiveEndDate: string;

  tobaccoUseLastReportDate: string;

  tobaccoFreeStatus: string;

  hasPrepopulationError: boolean;

  hasRequiredError: boolean;

  // fields from Member
  firstName: string;

  lastName: string;

  dateOfBirth: string;

  coveredIndividualId: string;

  isOffExchange: boolean;

  isOnExchange: boolean;

  constructor(
    isOverTobaccoAgeLimit: any,
    tobaccoIndicator = '',
    tobaccoUseEffectiveBeginDate = '',
    tobaccoUseEffectiveEndDate = '',
    tobaccoUseLastReportDate = '',
    tobaccoFreeStatus = '',
    hasPrepopulationError = false,
    hasRequiredError = false,
    firstName = '',
    lastName = '',
    dateOfBirth = '',
    coveredIndividualId = '',
    isOffExchange = false,
    isOnExchange = false,
  ) {
    this.isOverTobaccoAgeLimit = isOverTobaccoAgeLimit;
    this.tobaccoIndicator = tobaccoIndicator;
    this.tobaccoUseEffectiveBeginDate = tobaccoUseEffectiveBeginDate;
    this.tobaccoUseEffectiveEndDate = tobaccoUseEffectiveEndDate;
    this.tobaccoUseLastReportDate = tobaccoUseLastReportDate;
    this.tobaccoFreeStatus = tobaccoFreeStatus;
    this.hasPrepopulationError = hasPrepopulationError;
    this.hasRequiredError = hasRequiredError;
    this.firstName = firstName;
    this.lastName = lastName;
    this.dateOfBirth = dateOfBirth;
    this.coveredIndividualId = coveredIndividualId;
    this.isOffExchange = isOffExchange;
    this.isOnExchange = isOnExchange;
  }
}
